import { API_PARAM_IS_REDESIGN_CONTEXT } from '../../../constants/api'
import { getApi } from '../../../utils/api'

// Webapp auth endpoint reused as-is: exchanges the email hash for a temporary
// partner token. Response: `{ user_token, request: { id } }`.
export function getSharedRequest({
  hash,
  params = { [API_PARAM_IS_REDESIGN_CONTEXT]: 1 },
}) {
  return getApi({ endpoint: `/api/shared-request/${hash}/`, params })
}
